import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="bg-gray-900 text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <NavLink to="/" className="text-2xl font-bold">
            Helmets Off Football
          </NavLink>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <NavLink to="/" className="hover:text-yellow-400 transition">
              Home
            </NavLink>
            <NavLink to="/teams" className="hover:text-yellow-400 transition">
              Teams
            </NavLink>
            <NavLink to="/players" className="hover:text-yellow-400 transition">
              Players
            </NavLink>
            <NavLink
              to="/leaderboards"
              className="hover:text-yellow-400 transition"
            >
              Leaders
            </NavLink>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-3xl focus:outline-none"
          >
            ☰
          </button>
        </div>

        {/* Mobile Dropdown */}
        {open && (
          <div className="md:hidden bg-gray-800 py-4 rounded-b-xl">
            <NavLink to="/" className="block py-3 px-6 hover:bg-gray-700">
              Home
            </NavLink>
            <NavLink to="/teams" className="block py-3 px-6 hover:bg-gray-700">
              Teams
            </NavLink>
            <NavLink
              to="/players"
              className="block py-3 px-6 hover:bg-gray-700"
            >
              Players
            </NavLink>
            <NavLink
              to="/leaderboards"
              className="block py-3 px-6 hover:bg-gray-700"
            >
              Leaders
            </NavLink>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
